module.exports = __webpack_public_path__ + "img/icon-down.b73a247e.svg";